module.exports = __webpack_public_path__ + "img/rune-bounty.00e5cc37.png";